import { Config } from "@/hooks/useConfig";
import { Layer } from "@/Utils/hierarchy";

import { MROI_GRID_FILTERS, MROIColumnSelector, MROIGridFilter } from "./types";

const MROI_COLUMN_SELECTOR_LABELS = (config: Config) => {
  const currencySymbol = config.showReturnInsteadOfRevenue
    ? ""
    : `(${config.currency.getSymbol()})`;
  const { revenueLabel } = config;
  return {
    [MROIColumnSelector.ROI_PERCENTAGE]: "ROI (%)",
    [MROIColumnSelector.SPEND_VS_REVENUE_AMOUNT]: `Spend vs ${revenueLabel} ${currencySymbol}`,
    [MROIColumnSelector.SPEND_VS_REVENUE_PERCENTAGE]: `Spend vs ${revenueLabel} (%)`,
    [MROIColumnSelector.SHARE_OF_EFFECT_AMOUNT]: `Contribution to Brand Marketing ${revenueLabel} ${currencySymbol}`,
    [MROIColumnSelector.SHARE_OF_EFFECT_PERCENTAGE]: `Contribution to Brand Marketing ${revenueLabel} (%)`,
    [MROIColumnSelector.MARKETING_RETURN_AMOUNT]: `Marketing Return ${currencySymbol}`,
    [MROIColumnSelector.MARKETING_RETURN_PERCENTAGE]: `Marketing Return (%)`,
  };
};

export const getMROIGridFilterLabel = (filter: MROIGridFilter, config: Config): string => {
  const metadata = MROI_GRID_FILTERS[filter];
  if (!metadata) {
    return filter;
  }

  const currencySymbol = config.currency.getSymbol();

  // Replace generic funnel names with configured layer labels if available
  let label = metadata.label;
  if (metadata.category === "upper_funnel") {
    label = label.replace("Upper Funnel", config.getLayerLabel(Layer.Brand));
  } else if (metadata.category === "mid_funnel") {
    label = label.replace("Mid Funnel", config.getLayerLabel(Layer.Category));
  } else if (metadata.category === "lower_funnel") {
    label = label.replace("Lower Funnel", config.getLayerLabel(Layer.Product));
  }

  // Add appropriate suffix based on type
  if (metadata.type === "percentage") {
    return `${label} (%)`;
  } else if (metadata.type === "currency") {
    return `${label} (${currencySymbol})`;
  }

  return label;
};

export const getMROIColumnSelectorLabel = (columnSelector: MROIColumnSelector, config: Config) =>
  MROI_COLUMN_SELECTOR_LABELS(config)[columnSelector];

export const MarketingReturnLabel = {
  [MROIColumnSelector.MARKETING_RETURN_AMOUNT]: "Marketing Return",
  [MROIColumnSelector.MARKETING_RETURN_PERCENTAGE]: "Percentage of total marketing return",
};

export const getMarketingReturnLabel = (columnView: MROIColumnSelector) =>
  MarketingReturnLabel[columnView as keyof typeof MarketingReturnLabel];
